<template>
  <div v-if="hasTeam" class="teams-settings">
    <!-- We use flexbox grid here to stick to legacy grid
    Once we fully migrate and redesign the page
    we can remove the related classes and use our own container system
    -->
    <div class="middle-container">
      <div class="col-xs-12">
        <div class="teams-settings__seats-container">
          <div class="teams-settings__content">
            <h3 class="teams-settings__headline">
              {{ $t("headline") }}
            </h3>
            <p class="teams-settings__subheadline">
              {{ subheadlineText }}
            </p>
            <a class="teams-settings__manage-button cta cta--midnight" :href="buttonLink">
              {{ buttonText }}
            </a>
          </div>
          <div class="teams-settings__seats-counter">
            <seats-counter :max-seats="maxSeats" :filled-seats="filledSeats" :image-src="$options.teamSettingsImg" />
          </div>
        </div>
      </div>
    </div>

    <div class="middle-container">
      <div class="col-xs-12 col-sm-12">
        <div class="teams-settings__need-help">
          <div class="teams-settings__subheading">
            {{ $t("needHelp") }}
          </div>
          <div class="teams-settings__text" v-html="$t('contactSupport')" />
        </div>
      </div>
    </div>

    <legacy-divider-line />
  </div>
</template>

<script>
import { mapState } from "vuex"
import LegacyDividerLine from "features/settings/components/legacy-divider-line"
import globals from "utils/globals"
import SeatsCounter from "shared/seats-counter/seats-counter"
import teamSettingsImg from "../images/team-settings.svg"

export default {
  name: "TeamsSettingsController",
  components: {
    LegacyDividerLine,
    SeatsCounter
  },
  teamSettingsImg,
  computed: {
    ...mapState("teamsSettings", ["hasTeam", "maxSeats", "filledSeats", "isActiveOrganisation", "resubscribePath"]),
    buttonLink() {
      return this.isActiveOrganisation ? globals.routes.businessHome : this.resubscribePath
    },
    buttonText() {
      return this.isActiveOrganisation ? this.$i18n.t("partnerPortalButtonText") : this.$i18n.t("resubscribeButtonText")
    },
    subheadlineText() {
      return this.isActiveOrganisation ? this.$i18n.t("activeSubheadline") : this.$i18n.t("resubscribeSubheadline")
    }
  },
  mounted() {
    this.$store.dispatch("teamsSettings/loadTeam")
  },
  i18n: {
    messages: {
      en: {
        headline: "Partner Portal",
        activeSubheadline:
          "This is your Partner Portal, where you'll find your invite link to add people to your team. You'll see who's on your team, and be able to remove people here, too. The team owner seat is not counted in the seat number counter.",
        resubscribeSubheadline:
          "Your team account is currently inactive. Resubscribe to Blinkist Teams to get premium access for you and your team.",
        seats: "{filledSeats}/{maxSeats}",
        partnerPortalButtonText: "Go to Admin Home",
        resubscribeButtonText: "Resubscribe to Blinkist Teams",
        needHelp: "Need help?",
        contactSupport:
          "Contact <a href='mailto:support@blinkist.com'>support@blinkist.com</a> if you want to add more seats or need general help with your teams account."
      },
      de: {
        headline: "Partner Portal",
        activeSubheadline:
          "Klicke “Lizenzen verwalten” um den Einladungslink an weitere Teamkollegen zu schicken oder um vergebene Lizensen zurückzuziehen.",
        resubscribeSubheadline:
          "Dein Blinkist Teams Abonnement is aktuell nicht aktiv. Reaktivere es, um dir und deinem Team wieder Premium Zugriff auf alle Blinkist Inhalt zu gewähren.",
        seats: "{filledSeats}/{maxSeats}",
        partnerPortalButtonText: "Zur Admin-Startseite",
        resubscribeButtonText: "Abonnement reaktivieren",
        needHelp: "Brauchst du Hilfe?",
        contactSupport:
          "Kontaktiere <a href='mailto:support@blinkist.com'>support@blinkist.com</a>, um mehr Lizenzen hinzuzufügen oder wenn du allgemeine Hilfe brauchst."
      }
    }
  }
}
</script>

<style lang="scss">
.teams-settings {
  &__seats-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: $spacing-32;
    margin-bottom: $spacing-32;
    padding: $spacing-16 $spacing-16 $spacing-32;

    background-color: $pale-mint-grey;

    @include media(min-width, m) {
      flex-direction: row;
      justify-content: space-between;
      padding: $spacing-32 $spacing-32 $spacing-48;
    }

    @include media(min-width, l) {
      padding: $spacing-32 $spacing-128 $spacing-48 $spacing-64;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    margin-bottom: $spacing-24;

    @include media(min-width, m) {
      flex-basis: $wide-block-width;
      margin-bottom: 0;
    }
  }

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-32;
  }

  &__subheadline {
    margin-bottom: $spacing-32;
  }

  &__subheading {
    @include font-style(h5);

    margin-bottom: $spacing-16;
  }

  &__text {
    @include font-style(caption, $color: $mid-grey);

    margin-bottom: $spacing-16;
  }
}
</style>
